import { render, staticRenderFns } from "./ToggleButtonOrbit.vue?vue&type=template&id=d36789d2"
import script from "./ToggleButtonOrbit.vue?vue&type=script&lang=ts"
export * from "./ToggleButtonOrbit.vue?vue&type=script&lang=ts"
import style0 from "./ToggleButtonOrbit.vue?vue&type=style&index=0&id=d36789d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports